/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from 'react';
import SalidasDB from '../firebase/SalidasDB';
import CabeceraOutDB from '../firebase/CabeceraOutDB';
import Alertas from './Alertas';
import validarRut from '../funciones/validarRut';
import { Table, Container, Segment,Dropdown, Form, Button, Icon, Input, Label } from 'semantic-ui-react';
import { auth, db } from '../firebase/firebaseConfig';
import { getDocs, getDoc, collection, where, query, doc, writeBatch, deleteDoc } from 'firebase/firestore';
import { TipDocOut, TipoOut } from './TipDoc';
import moment from 'moment';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { ConfirmaModal,  Overlay } from '../elementos/General';
import EnviarCorreo from '../funciones/EnviarCorreo';
import Swal from 'sweetalert2';
import BuscadorInput from './BuscadorInput';
import Spinner from "./Spinner";
/* import subirArchivos from '.././funciones/subirArchivos'; */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";
import { PDFViewer } from "@react-pdf/renderer";
import DocumentoSalidaPDF from "./DocumentoSalidaPDF";

const sectionTitleStyle = {
    color: "#344563",
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 10,
    marginTop: 2,
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    display: "flex",
    alignItems: "center",
    gap: 4,
};

const stickyTh = {
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#f8fafc",
    color: "#344563",
    fontWeight: 600,
};

const Salidas = () => {
    //lee usuario de autenticado y obtiene fecha actual
    const user = auth.currentUser;
    const { users } = useContext(UserContext);
    let fechaAdd = new Date();


    // Calcular la fecha mínima (3 días hacia atrás)
    const fechaMinima = new Date();
    fechaMinima.setDate(fechaAdd.getDate() - 1);
    // Calcular la fecha máxima (3 días hacia adelante)
    const fechaMaxima = new Date();
    fechaMaxima.setDate(fechaAdd.getDate() + 1);

    const [seccionActiva, setSeccionActiva] = useState("CABECERA");
    const [cargando, setCargando] = useState(false);
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationAnular, setShowConfirmationAnular] = useState(false);
    const [itemDelete, setItemdelete] = useState(false);
    const [itemAnular, setItemAnular] = useState(false);
    const [alerta, cambiarAlerta] = useState({});
    const [alertaSalida, setAlertasalida] = useState([]);
    const [cabecera, setCabecera] = useState([]);
    const [empresa, setEmpresa] = useState([]);
    const [cabecera1, setCabecera1] = useState([]);
    const [dataSalida, setDataSalida] = useState([]);
    const [status, setStatus] = useState([]);
    const [usuario, setUsuarios] = useState([]);
    const [transport, setTransport] = useState([]);
    const [x, setX] = useState([]);
    const [numDoc, setNumDoc] = useState('');
    const [nomTipDoc, setNomTipDoc] = useState('');
    const [date, setDate] = useState(new Date());
    const [nomTipoOut, setNomTipoOut] = useState('');
    const [rut, setRut] = useState('');
    const [entidad, setEntidad] = useState('');
    const [correo, setCorreo] = useState('');
    const [patente, setPatente] = useState('');
    const [numSerie, setNumSerie] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [flag, setFlag] = useState(false);
    const [confirmar, setConfirmar] = useState(false);
    const [btnGuardar, setBtnGuardar] = useState(false);
    const [btnAgregar, setBtnAgregar] = useState(true);
    const [btnConfirmar, setBtnConfirmar] = useState(true);
    const [btnNuevo, setBtnNuevo] = useState(false);
    const [cabeceraMinimizada, setCabeceraMinimizada] = useState(false);
    const [detalleMinimizado, setDetalleMinimizado] = useState(true);
    const [showConfirmarDocumento, setShowConfirmarDocumento] = useState(false);
    const [guardandoCabecera, setGuardandoCabecera] = useState(false);
    const [guardandoDetalle, setGuardandoDetalle] = useState(false);
    const [confirmandoDocumento, setConfirmandoDocumento] = useState(false);
    const [ultimoItemAgregadoId, setUltimoItemAgregadoId] = useState(null);
    const [modalBuscarEquipo, setModalBuscarEquipo] = useState(false);
    const [equiposBusqueda, setEquiposBusqueda] = useState([]);
    const [textoBusquedaEquipo, setTextoBusquedaEquipo] = useState('');
    const [cargandoBusqueda, setCargandoBusqueda] = useState(false);
    const [ultimosConfirmados, setUltimosConfirmados] = useState([]);
    const [modalPDF, setModalPDF] = useState(false);
    const [cabeceraPDF, setCabeceraPDF] = useState(null);
    const [detallePDF, setDetallePDF] = useState([]);
    const [cargandoPDFId, setCargandoPDFId] = useState(null);
    /*  const [archivo, setArchivo] = useState(null); */

    // ID exacto de la cabecera de salida que está en proceso
    const [cabeceraId, setCabeceraId] = useState(null);

    const detalleTablaRef = useRef(null);
    const almacenar = useRef([]);
    const salidaid = useRef([]);
    const nomRut = useRef('Rut');
    /*  const cabid = useRef(''); */

    //Lectura de usuario para alertas de salida
    const getAlertasSalidas = async () => {
        if (!users) return;
        const traerAlertas = collection(db, 'usuariosalertas');
        const dato = query(traerAlertas, where('emp_id', '==', users.emp_id), where('salida', '==', true));
        const data = await getDocs(dato);
        setAlertasalida(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    // Filtar por docuemto de Cabecera
    const consultarCab = async () => {
        if (!users) return;
        const cab = query(collection(db, 'salidasCab'), where('emp_id', '==', users.emp_id), where('confirmado', '==', false), where('tipmov', '==', 2));
        const guardaCab = await getDocs(cab);
        setCabecera(guardaCab.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        const cab1 = query(collection(db, 'salidasCab'), where('emp_id', '==', users.emp_id), where('confirmado', '==', false), where('tipmov', '==', 0));
        const guardaCab1 = await getDocs(cab1);
        setCabecera1(guardaCab1.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    }
    const merge = [...cabecera, ...cabecera1].sort((a, b) => a.numdoc - b.numdoc)

    //Funcion ordena x fecha
    const OrdenaFecha = (a, b) => {
        return a.fechaadd.seconds - b.fechaadd.seconds;
    }
    // Filtar por docuemto de Salida
    const consultarOut = async () => {
        if (!users?.emp_id) return;

        if (!cabeceraId) {
            setDataSalida([]);
            return;
        }

        try {
            const q = query(
                collection(db, 'salidas'),
                where('emp_id', '==', users.emp_id),
                where('cab_id', '==', cabeceraId)
            );

            const snap = await getDocs(q);

            const documentos = snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }));

            setDataSalida(documentos.sort(OrdenaFecha));

        } catch (error) {
            console.error('Error al consultar detalle de salida:', error);

            setDataSalida([]);

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'Error al consultar detalle del documento',
            });
        }
    };
    // Filtar usuario transportista
    const transportista = async () => {
        if (!users) return;
        const trans = query(collection(db, 'usuarios'), where('emp_id', '==', users.emp_id)/* , where('rol', '==', 'TRANSPORTE-HC') */);
        const transporte = await getDocs(trans);
        const transportista = (transporte.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setTransport(transportista);
    }
    //Lectura de status
    const getStatus = async () => {
        if (!users) return;
        const traerEntrada = collection(db, 'status');
        const dato = query(traerEntrada, where('emp_id', '==', users.emp_id));
        const data = await getDocs(dato)
        setStatus(data.docs.map((doc, index) => ({ ...doc.data(), id: doc.id, id2: index + 1 })))
    }
    //Lee datos de los usuarios
    const getUsuarios = async () => {
        if (!users) return;
        const dataUsuarios = collection(db, "usuarios");
        const dato = query(dataUsuarios, where('emp_id', '==', users.emp_id));
        const data = await getDocs(dato)
        setUsuarios(data.docs.map((emp, index) => ({ ...emp.data(), id: emp.id, id2: index + 1 })))
    }
    //Leer  Empresa
    const getEmpresa = async () => {
        if (!users) return;
        const traerEmp = await getDoc(doc(db, 'empresas', users.emp_id));
        setEmpresa(traerEmp.data());
    }
    //Traer Clientes
    const consultarClientes = async () => {
        if (!users) return;
        const sqlCte = query(collection(db, 'clientes'), where('emp_id', '==', users.emp_id));
        const Ctes = await getDocs(sqlCte);
        const existeCtes = (Ctes.docs.map((doc, index) => ({ ...doc.data(), id: doc.id })))
        setX(existeCtes);
    }

    //Traer Proveedores
    const consultarProv = async () => {
        if (!users) return;
        const sqlCte = query(collection(db, 'proveedores'), where('emp_id', '==', users.emp_id));
        const Ctes = await getDocs(sqlCte);
        const existeCtes = (Ctes.docs.map((doc, index) => ({ ...doc.data(), id: doc.id })))
        setX(existeCtes);
    }

    const consultarUltimosConfirmados = async () => {
        if (!users) return;

        try {
            const q = query(
                collection(db, "salidasCab"),
                where("emp_id", "==", users.emp_id),
                where("confirmado", "==", true)
            );

            const snap = await getDocs(q);

            const docs = snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }));

            const ordenados = docs
                .sort((a, b) => {
                    const fechaA =
                        a.fechamod?.seconds ||
                        a.fechaMod?.seconds ||
                        a.fechaadd?.seconds ||
                        a.fechaAdd?.seconds ||
                        a.date?.seconds ||
                        0;

                    const fechaB =
                        b.fechamod?.seconds ||
                        b.fechaMod?.seconds ||
                        b.fechaadd?.seconds ||
                        b.fechaAdd?.seconds ||
                        b.date?.seconds ||
                        0;

                    return fechaB - fechaA;
                })
                .slice(0, 5);

            setUltimosConfirmados(ordenados);
        } catch (error) {
            console.log("Error últimos confirmados:", error);
            setUltimosConfirmados([]);
        }
    };


    const obtenerDetalleDocumento = async (cabId) => {
        const q = query(
            collection(db, "salidas"),
            where("emp_id", "==", users.emp_id),
            where("cab_id", "==", cabId)
        );

        const snap = await getDocs(q);

        return snap.docs.map((docu, index) => ({
            ...docu.data(),
            id: docu.id,
            id2: index + 1,
        }));
    };

    const mostrarError = (mensaje) => {
        cambiarEstadoAlerta(true);
        cambiarAlerta({ tipo: "error", mensaje });
    };

    const verPDFDocumento = async (cab) => {
        setCargandoPDFId(cab.id);

        try {
            const detalle = await obtenerDetalleDocumento(cab.id);

            setCabeceraPDF(cab);
            setDetallePDF(detalle);
            setModalPDF(true);
        } catch (error) {
            mostrarError("Error al cargar PDF");
        } finally {
            setCargandoPDFId(null);
        }
    };

    //Seleccionar valores del cliente traidos del componente buscadorInput
    const handleSelectItem = (item) => {
        const isObject = item !== null && typeof item === 'object';//Valida si dato es un objeto o un valor normal
        if (isObject) {
            setRut(item.rut);
            setEntidad(item.nombre);
        } else {
            //Patron para validar rut
            const expresionRegularRut = /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;
            const temp = item.split('-');
            let digito = temp[1];
            if (digito === 'k' || digito === 'K') digito = -1;
            const validaR = validarRut(item);
            if (item === '') {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'Favor ingresa un rut'
                })
                return;
            } else if (!expresionRegularRut.test(item)) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'Formato incorrecto de rut'
                })
                return;
            } else if (validaR !== parseInt(digito)) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'Rut no válido'
                })
                return;
            } else {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'No existe rut de proveedor'
                })
            }
        };
    }
    //Limpia formulario Clientes
    const limpiaFormCte = () => {
        setRut('');
        setEntidad('');
    }

    // Cambiar fecha
    const formatearFecha = (fecha) => {
        const dateObj = fecha.toDate();
        const formatear = moment(dateObj).format('DD/MM/YYYY HH:mm:ss');
        return formatear;
    }
    // Transformar fecha de moment a date
    const fechaDate = (fecha) => {
        // Convierte a milisegundos
        const nuevaFecha = fecha.seconds * 1000
        // Crea un objeto Date a partir del timestamp en milisegundos
        const fechas = new Date(nuevaFecha);
        // Formatea la fecha en el formato 'YYYY-MM-DDTHH:mm'
        const formatoDatetimeLocal = fechas.toISOString().slice(0, 16);
        setDate(formatoDatetimeLocal)
    }
    // Cambiar Label de Rut
    if (nomTipoOut === 'PACIENTE' || nomTipoOut === 'RETIRO PACIENTE') {
        nomRut.current = 'Rut Paciente';
    } else if (nomTipoOut === 'SERVICIO TECNICO' || nomTipoOut === 'RETIRO SERVICIO TECNICO') {
        nomRut.current = 'Rut Servicio Tecnico';
    } else {
        nomRut.current = 'Rut Proveedor';
    }

    // Validar N°serie
    const detectar = async (e) => {
        cambiarEstadoAlerta(false);
        cambiarAlerta({});
        if (e.key === 'Enter' || e.key === 'Tab') {
            // Exite N° serie en equipos   
            const traerEq = query(collection(db, 'equipos'), where('emp_id', '==', users.emp_id), where('serie', '==', numSerie));
            const serieEq = await getDocs(traerEq);
            const existe = (serieEq.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            // Exite ID en equipos
            const traerId = await getDoc(doc(db, 'equipos', numSerie));
            if (existe.length === 1) {
                almacenar.current = existe;
            } else if (traerId.exists()) {
                const existeId = traerId.data();
                const arreglo = [existeId];
                const existe2 = arreglo.map((doc) => ({ ...doc, id: numSerie }));
                almacenar.current = existe2;
            } else {
                console.log('almacenar', almacenar.current);
            }
            // Exite N° serie en Entradas 
            const existeIn = dataSalida.filter(doc => doc.serie === numSerie);
            const existeIn2 = dataSalida.filter(doc => doc.eq_id === numSerie);
            // Validar en N° Serie en todos los documento de Salidas confirmado
            const traerSC = query(collection(db, 'salidas'), where('emp_id', '==', users.emp_id), where('serie', '==', numSerie), where('confirmado', '==', false));
            const confirmadoS = await getDocs(traerSC);
            const existeconfirmado = (confirmadoS.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            // Validar en Eq_id en todos los documento de Salidas confirmado
            const traerID = query(collection(db, 'salidas'), where('emp_id', '==', users.emp_id), where('eq_id', '==', numSerie), where('confirmado', '==', false));
            const confirmadoID = await getDocs(traerID);
            const existeID = (confirmadoID.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            // Validar que equipo pertenezca a proveedor y que este en arriendo
            const traer = query(collection(db, 'entradas'), where('emp_id', '==', users.emp_id), where('serie', '==', numSerie), where('rut', '==', rut), where('tipoinout', '==', 'ARRIENDO'));
            const valida = await getDocs(traer);
            const existeeqprov = (valida.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

            if (almacenar.current.length === 0) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'No existe un Equipo con este N° Serie o Id'
                })
            } else if (existeIn.length > 0 || existeIn2.length > 0) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'Equipo ya se encuentra en este documento'
                })
            } else if (existeconfirmado.length > 0 || existeID.length > 0) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'Equipo ya se encuentra Ingresado en un documento por confirmar'
                })
            } else {
                const existeStatusCli = status.filter(st => st.id === almacenar.current[0].id && st.status === 'PACIENTE').length === 1;
                const existeStatusST = status.filter(st => st.id === almacenar.current[0].id && st.status === 'SERVICIO TECNICO').length === 1;
                const existeStatusBod = status.filter(st => st.id === almacenar.current[0].id && st.status === 'BODEGA').length === 1;
                if (nomTipoOut === 'RETIRO PACIENTE') {
                    if (!existeStatusCli) {
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: 'error',
                            mensaje: 'Equipo no se encuentra en Paciente'
                        })
                    }
                } else if (nomTipoOut === 'RETIRO SERVICIO TECNICO') {
                    if (!existeStatusST) {
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: 'error',
                            mensaje: 'Equipo no se encuentra en Servicio Tecnico'
                        })
                    }
                } else if (nomTipoOut === 'DEVOLUCION A PROVEEDOR' && existeeqprov.length === 0) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'Equipo no pertenece a este Proveedor o no ha sido arrendado'
                    })
                } else {
                    if (!existeStatusBod) {
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: 'error',
                            mensaje: 'Equipo no se encuentra en Bodega'
                        })
                    }
                }
            }
        }
    }

    // Guardar Cabecera de Documento en Coleccion CabeceraInDB
    const addCabeceraIn = async (ev) => {
        ev.preventDefault();

        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        if (!users?.emp_id) {
            mostrarError('No se pudo identificar la empresa');
            return;
        }

        setGuardandoCabecera(true);

        try {
            // =====================================================
            // VALIDACIONES GENERALES
            // =====================================================

            const expresionRegularRut =
                /^[0-9]+[-‐][0-9kK]$/;

            const expresionRegularCorreo =
                /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

            if (!numDoc) {
                mostrarError('Ingrese N° Documento');
                return;
            }

            if (
                !nomTipDoc ||
                nomTipDoc === 'Selecciona Opción:'
            ) {
                mostrarError('Seleccione Tipo Documento');
                return;
            }

            if (!date) {
                mostrarError('Seleccione una Fecha');
                return;
            }

            if (
                !nomTipoOut ||
                nomTipoOut === 'Selecciona Opción:'
            ) {
                mostrarError('Seleccione un Tipo de Salida');
                return;
            }

            if (!rut) {
                mostrarError('Campo Rut no puede estar vacío');
                return;
            }

            if (!expresionRegularRut.test(rut)) {
                mostrarError('Formato incorrecto de rut');
                return;
            }

            const temp = rut.split('-');
            let digito = temp[1];

            if (digito === 'k' || digito === 'K') {
                digito = -1;
            }

            const validaR = validarRut(rut);

            if (validaR !== parseInt(digito)) {
                mostrarError('Rut no válido');
                return;
            }

            if (!correo) {
                mostrarError('Ingrese un correo');
                return;
            }

            if (!expresionRegularCorreo.test(correo)) {
                mostrarError('Favor ingresar un correo válido');
                return;
            }

            const existeCorreo = usuario.some(
                (u) => u.correo === correo
            );

            if (!existeCorreo) {
                mostrarError(
                    'No existe usuario con ese correo'
                );
                return;
            }

            if (!patente) {
                mostrarError(
                    'Ingrese Patente del Vehículo'
                );
                return;
            }

            // =====================================================
            // DETERMINAR TIPMOV
            // =====================================================

            const esRetiro =
                nomTipoOut === 'RETIRO PACIENTE' ||
                nomTipoOut === 'RETIRO SERVICIO TECNICO';

            const tipMov = esRetiro ? 0 : 2;

            // =====================================================
            // VALIDAR DUPLICADO
            // =====================================================

            const qCab = query(
                collection(db, 'salidasCab'),
                where('emp_id', '==', users.emp_id),
                where('numdoc', '==', parseInt(numDoc)),
                where('tipdoc', '==', nomTipDoc),
                where('rut', '==', rut),
                where('tipmov', '==', tipMov)
            );

            const snapCab = await getDocs(qCab);

            if (!snapCab.empty) {
                const existente =
                    snapCab.docs[0].data();

                if (existente.confirmado) {
                    mostrarError(
                        'Ya existe este documento y se encuentra confirmado'
                    );
                } else {
                    mostrarError(
                        'Ya existe este documento. Falta confirmar'
                    );
                }

                return;
            }

            // =====================================================
            // DETERMINAR ENTIDAD
            // =====================================================

            let nombreEntidad = '';

            if (
                nomTipoOut === 'PACIENTE' ||
                nomTipoOut === 'RETIRO PACIENTE'
            ) {
                const qCliente = query(
                    collection(db, 'clientes'),
                    where('emp_id', '==', users.emp_id),
                    where('rut', '==', rut)
                );

                const snapCliente =
                    await getDocs(qCliente);

                if (snapCliente.empty) {
                    mostrarError(
                        'No existe rut del Paciente'
                    );
                    return;
                }

                nombreEntidad =
                    snapCliente.docs[0].data().nombre || '';

            } else {

                const qProveedor = query(
                    collection(db, 'proveedores'),
                    where('emp_id', '==', users.emp_id),
                    where('rut', '==', rut)
                );

                const snapProveedor =
                    await getDocs(qProveedor);

                if (snapProveedor.empty) {
                    mostrarError(
                        'No existe rut de proveedor'
                    );
                    return;
                }

                nombreEntidad =
                    snapProveedor.docs[0].data().nombre || '';
            }

            // Actualizamos la pantalla
            setEntidad(nombreEntidad);

            // =====================================================
            // CREAR CABECERA
            // =====================================================

            const fechaInOut =
                date instanceof Date
                    ? date
                    : new Date(date);

            const esSalida =
                !esRetiro;

            const cabeceraCreada =
                await CabeceraOutDB({
                    numDoc: parseInt(numDoc),
                    tipDoc: nomTipDoc,
                    date: fechaInOut,
                    tipoInOut: nomTipoOut,
                    rut,
                    entidad: nombreEntidad,
                    correo,
                    patente,
                    descripcion,
                    tipMov,
                    url: '',
                    confirmado: false,

                    entregado: esRetiro,
                    retirado: esSalida,

                    observacion: '',
                    userAdd: user?.email || '',
                    userMod: user?.email || '',
                    fechaAdd: new Date(),
                    fechaMod: new Date(),
                    emp_id: users.emp_id,

                    rutSt: '',
                    entidadSt: '',
                });

            /*
             * CabeceraOutDB debe retornar el documento creado,
             * igual que CabeceraInDB.
             */
            if (!cabeceraCreada?.id) {
                throw new Error(
                    'No se recibió el ID de la cabecera creada'
                );
            }

            setCabeceraId(cabeceraCreada.id);

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'exito',
                mensaje:
                    'Cabecera Documento guardada exitosamente',
            });

            setConfirmar(true);
            setBtnAgregar(false);
            setBtnGuardar(true);
            setBtnNuevo(false);

            setCabeceraMinimizada(true);
            setDetalleMinimizado(false);
            setSeccionActiva("DETALLE");
            setFlag((prev) => !prev);

        } catch (error) {
            console.error(
                'Error al crear cabecera de salida:',
                error
            );

            mostrarError(
                error?.message ||
                'Error al guardar cabecera'
            );

        } finally {
            setGuardandoCabecera(false);
        }
    };

    const obtenerEstadoSalida = (tipoSalida) => {
        switch (tipoSalida) {

            case 'PACIENTE':
                return 'TRANSITO PACIENTE';

            case 'SERVICIO TECNICO':
            case 'S. TECNICO PREVENTIVO':
                return 'TRANSITO S.T.';

            case 'DEVOLUCION A PROVEEDOR':
                return 'TRANSITO A PROVEEDOR';

            case 'RETIRO PACIENTE':
                return 'PROCESO RETIRO PACIENTE';

            case 'RETIRO SERVICIO TECNICO':
                return 'PROCESO RETIRO S.T.';

            case 'BAJA':
                return 'BAJA';

            default:
                return '';
        }
    };

    const handleSubmit = async (e, equipoSeleccionado = null) => {
        e?.preventDefault?.();

        cambiarEstadoAlerta(false);
        cambiarAlerta({});
        setGuardandoDetalle(true);

        try {
            // =====================================================
            // 1. VALIDAR CABECERA ACTIVA
            // =====================================================

            if (!cabeceraId) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje: "No existe una cabecera activa para este documento",
                });
                return;
            }

            // =====================================================
            // 2. OBTENER SERIE / ID DEL EQUIPO
            // =====================================================

            const serieBuscada =
                equipoSeleccionado?.serie ||
                equipoSeleccionado?.id ||
                numSerie;

            if (!serieBuscada || serieBuscada.trim() === "") {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje: "Ingrese o escanee N° Serie",
                });
                return;
            }

            const valorBuscado = serieBuscada.trim();

            // =====================================================
            // 3. BUSCAR EQUIPO POR SERIE
            // =====================================================

            const traerEq = query(
                collection(db, "equipos"),
                where("emp_id", "==", users.emp_id),
                where("serie", "==", valorBuscado)
            );

            const serieEq = await getDocs(traerEq);

            let equipoEncontrado = serieEq.docs.map((docu) => ({
                ...docu.data(),
                id: docu.id,
            }));

            // =====================================================
            // 4. CONTROL DE SERIES DUPLICADAS
            // =====================================================

            if (equipoEncontrado.length > 1) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "Existen varios equipos con la misma serie. Revise la integridad del maestro de equipos.",
                });
                return;
            }

            // =====================================================
            // 5. SI NO ENCUENTRA POR SERIE, BUSCAR POR ID
            // =====================================================

            if (equipoEncontrado.length === 0) {
                const traerId = await getDoc(
                    doc(db, "equipos", valorBuscado)
                );

                if (
                    traerId.exists() &&
                    traerId.data()?.emp_id === users.emp_id
                ) {
                    equipoEncontrado = [
                        {
                            ...traerId.data(),
                            id: traerId.id,
                        },
                    ];
                }
            }

            if (equipoEncontrado.length === 0) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje: "No existe un equipo con este N° Serie o ID",
                });
                return;
            }

            const equipo = equipoEncontrado[0];

            // =====================================================
            // 6. VALIDAR DUPLICADO EN DOCUMENTO ACTUAL
            // =====================================================

            const existeEnDocumento = dataSalida.some(
                (docu) =>
                    docu.serie === equipo.serie ||
                    docu.eq_id === equipo.id
            );

            if (existeEnDocumento) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje: "Equipo ya se encuentra en este documento",
                });
                return;
            }

            // =====================================================
            // 7. VALIDAR OTRO DOCUMENTO DE SALIDA PENDIENTE
            // =====================================================

            const traerSC = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("serie", "==", equipo.serie),
                where("confirmado", "==", false)
            );

            const traerID = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("eq_id", "==", equipo.id),
                where("confirmado", "==", false)
            );

            const [confirmadoS, confirmadoID] = await Promise.all([
                getDocs(traerSC),
                getDocs(traerID),
            ]);

            if (!confirmadoS.empty || !confirmadoID.empty) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "Equipo ya se encuentra ingresado en un documento por confirmar",
                });
                return;
            }

            // =====================================================
            // 8. OBTENER STATUS ACTUAL DIRECTAMENTE DESDE FIRESTORE
            // =====================================================

            const statusRef = doc(db, "status", equipo.id);
            const statusSnap = await getDoc(statusRef);

            if (!statusSnap.exists()) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "El equipo no posee registro de estado. Revise la información del equipo.",
                });
                return;
            }

            const statusEquipo = {
                ...statusSnap.data(),
                id: statusSnap.id,
            };

            // =====================================================
            // 9. VALIDACIONES SEGÚN TIPO DE SALIDA
            // =====================================================

            const existeStatusBod =
                statusEquipo.status === "BODEGA";

            const existeStatusCli =
                statusEquipo.status === "PACIENTE" &&
                statusEquipo.r_destino === rut;

            const existeStatusST =
                statusEquipo.status === "SERVICIO TECNICO" &&
                statusEquipo.r_destino === rut;

            let tipMov = 2;

            // -----------------------------------------------------
            // RETIRO DESDE PACIENTE
            // -----------------------------------------------------

            if (nomTipoOut === "RETIRO PACIENTE") {
                if (!existeStatusCli) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: "error",
                        mensaje:
                            "Equipo no se encuentra en este paciente",
                    });
                    return;
                }

                tipMov = 0;
            }

            // -----------------------------------------------------
            // RETIRO DESDE SERVICIO TÉCNICO
            // -----------------------------------------------------

            else if (
                nomTipoOut === "RETIRO SERVICIO TECNICO"
            ) {
                if (!existeStatusST) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: "error",
                        mensaje:
                            "Equipo no se encuentra en Servicio Técnico",
                    });
                    return;
                }

                tipMov = 0;
            }

            // -----------------------------------------------------
            // SALIDAS DESDE BODEGA
            // -----------------------------------------------------

            else {
                // DEVOLUCIÓN A PROVEEDOR
                if (
                    nomTipoOut === "DEVOLUCION A PROVEEDOR"
                ) {
                    const traer = query(
                        collection(db, "entradas"),
                        where("emp_id", "==", users.emp_id),
                        where("serie", "==", equipo.serie),
                        where("rut", "==", rut),
                        where("tipoinout", "in", [
                            "COMPRA",
                            "ARRIENDO",
                        ])
                    );

                    const valida = await getDocs(traer);

                    if (valida.empty) {
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: "error",
                            mensaje:
                                "Equipo no pertenece a este proveedor o no ha sido comprado/arrendado",
                        });
                        return;
                    }
                }

                // Para salidas normales el equipo debe estar en bodega
                if (!existeStatusBod) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: "error",
                        mensaje:
                            "Equipo no se encuentra en Bodega",
                    });
                    return;
                }
            }

            // =====================================================
            // 10. GUARDAR DETALLE
            // =====================================================

            await SalidasDB({
                numDoc: parseInt(numDoc),
                tipDoc: nomTipDoc,

                // usamos la fecha de la cabecera activa
                date: date,

                tipoInOut: nomTipoOut,

                rut: rut,
                entidad: entidad,

                correo: correo,
                patente: patente,

                // relación directa con la cabecera
                cab_id: cabeceraId,

                eq_id: equipo.id,

                familia: equipo.familia || "",
                tipo: equipo.tipo || "",
                marca: equipo.marca || "",
                modelo: equipo.modelo || "",
                serie: equipo.serie || "",
                rfid: equipo.rfid || "",

                tipMov: tipMov,

                observacion: "",
                historial: 0,

                confirmado: false,

                userAdd: user?.email || "",
                userMod: user?.email || "",

                fechaAdd: new Date(),
                fechaMod: new Date(),

                emp_id: users.emp_id,
            });

            // =====================================================
            // 11. LIMPIAR Y ACTUALIZAR PANTALLA
            // =====================================================

            setUltimoItemAgregadoId(equipo.id);

            setNumSerie("");

            almacenar.current = [];
            salidaid.current = [];

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "exito",
                mensaje: "Item guardado correctamente",
            });

            setFlag((prev) => !prev);

            setBtnConfirmar(false);
            setBtnNuevo(false);

            setTimeout(() => {
                setUltimoItemAgregadoId(null);
            }, 2500);

        } catch (error) {
            console.error("Error handleSubmit salida:", error);

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje:
                    error?.message ||
                    "Error al guardar equipo",
            });
        } finally {
            setGuardandoDetalle(false);
        }
    };

    // Función para actualizar varios documentos por lotes
    const actualizarDocs = async () => {
        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        if (!cabeceraId) {
            mostrarError(
                'No existe una cabecera activa para confirmar'
            );
            return;
        }

        if (dataSalida.length === 0) {
            Swal.fire(
                'No hay datos por confirmar en este documento'
            );
            return;
        }

        const estadoSalida =
            obtenerEstadoSalida(nomTipoOut);

        if (!estadoSalida) {
            mostrarError(
                `No existe estado definido para ${nomTipoOut}`
            );
            return;
        }

        const batch = writeBatch(db);
        const ahora = new Date();

        // =====================================================
        // ACTUALIZAR STATUS DE EQUIPOS
        // =====================================================

        dataSalida.forEach((item) => {
            const statusRef = doc(
                db,
                'status',
                item.eq_id
            );

            batch.update(statusRef, {
                status:
                    item.estado_destino ||
                    estadoSalida,

                r_origen:
                    empresa?.rut || '',

                n_origen:
                    empresa?.empresa || '',

                r_destino:
                    item.rut || rut,

                n_destino:
                    item.entidad || entidad,

                fechamod:
                    ahora,
            });
        });

        // =====================================================
        // CONFIRMAR DETALLES
        // =====================================================

        dataSalida.forEach((item) => {
            const salidaRef = doc(
                db,
                'salidas',
                item.id
            );

            batch.update(salidaRef, {
                confirmado: true,
                fechamod: ahora,
            });
        });

        // =====================================================
        // CONFIRMAR CABECERA
        // Lo hacemos dentro del mismo batch.
        // =====================================================

        const cabeceraRef = doc(
            db,
            'salidasCab',
            cabeceraId
        );

        batch.update(cabeceraRef, {
            confirmado: true,
            usermod: user?.email || '',
            fechamod: ahora,
        });

        // =====================================================
        // COMMIT ÚNICO
        // =====================================================

        await batch.commit();

        cambiarEstadoAlerta(true);
        cambiarAlerta({
            tipo: 'exito',
            mensaje:
                'Documento de salida confirmado exitosamente.',
        });

        // =====================================================
        // CORREO DE ALERTA
        // =====================================================

        if (
            nomTipoOut === 'PACIENTE' ||
            nomTipoOut === 'SERVICIO TECNICO'
        ) {
            try {
                const mensaje =
                    cuerpoCorreo(dataSalida);

                alertaSalida.forEach((destino) => {
                    EnviarCorreo(
                        destino.correo,
                        'Alerta Salida de Bodega',
                        mensaje
                    );
                });

            } catch (error) {
                console.error(
                    'Error enviando alerta de salida:',
                    error
                );
            }
        }

        // =====================================================
        // LIMPIAR
        // =====================================================

        setCabeceraId(null);

        setNomTipDoc('');
        setNumDoc('');

        setDate(new Date());

        setNomTipoOut('');

        setRut('');
        setEntidad('');

        setCorreo('');
        setPatente('');

        setNumSerie('');
        setDescripcion('');

        setConfirmar(false);

        setBtnGuardar(false);
        setBtnAgregar(true);
        setBtnConfirmar(true);
        setBtnNuevo(true);

        setCabeceraMinimizada(false);
        setDetalleMinimizado(true);

        setDataSalida([]);

        almacenar.current = [];
        salidaid.current = [];

        await consultarUltimosConfirmados();

        setFlag((prev) => !prev);
    };

    const handleDelete = (itemId) => {
        setItemdelete(itemId);
        setShowConfirmation(true);
    }
    const cancelDelete = () => {
        setShowConfirmation(false);
    }
    const borrarItem = async () => {
        if (itemDelete) {
            try {
                await deleteDoc(doc(db, "salidas", itemDelete));
                setFlag(!flag);
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'exito',
                    mensaje: 'Item eliminado exitosamente.'
                });
            } catch (error) {
                console.log('Error al eliminar items');
            }
        }
        setShowConfirmation(false);
    }

    const handleAnular = (itemId) => {
        setItemAnular(itemId);
        setShowConfirmationAnular(true);
    }
    const cancelAnular = () => {
        setShowConfirmationAnular(false);
    }
    const anular = async () => {
        if (!itemAnular || !users?.emp_id) {
            mostrarError(
                'No se pudo identificar el documento a anular'
            );
            return;
        }

        try {
            const qDetalle = query(
                collection(db, 'salidas'),
                where('emp_id', '==', users.emp_id),
                where('cab_id', '==', itemAnular)
            );

            const snapDetalle =
                await getDocs(qDetalle);

            const batch =
                writeBatch(db);

            // Cabecera
            const cabeceraRef = doc(
                db,
                'salidasCab',
                itemAnular
            );

            batch.update(cabeceraRef, {
                tipmov: 3,
                fechamod: new Date(),
                usermod: user?.email || '',
            });

            // Detalle
            snapDetalle.docs.forEach((documento) => {
                batch.delete(documento.ref);
            });

            await batch.commit();

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'exito',
                mensaje: 'Documento Anulado.',
            });

            setCabeceraId(null);

            setNumDoc('');
            setNomTipDoc('');

            setDate(new Date());

            setNomTipoOut('');

            setRut('');
            setEntidad('');

            setCorreo('');
            setPatente('');

            setNumSerie('');
            setDescripcion('');

            setConfirmar(false);

            setBtnGuardar(false);
            setBtnAgregar(true);
            setBtnConfirmar(true);
            setBtnNuevo(true);

            setCabeceraMinimizada(false);
            setDetalleMinimizado(true);

            setDataSalida([]);

            almacenar.current = [];
            salidaid.current = [];

            setFlag((prev) => !prev);

        } catch (error) {
            console.error(
                'Error al anular documento:',
                error
            );

            mostrarError(
                'Error al anular documento'
            );

        } finally {
            setShowConfirmationAnular(false);
        }
    };
    //Funcion para subir archivos al storega
    /* const subida = async (e) => {
        e.preventDefault();
        if (archivo !== null) {
            try {
                const result = await subirArchivos(archivo);
                console.log(result)
                window.open(result, '_blank');
            } catch (error) {
                console.log(error)
            }
        } else {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'No ha seleccionado ningun archivo'
            })
        }

    } */

    const cuerpoCorreo = (data = []) => {
        if (!data.length) return "";

        const {
            tipoinout,
            numdoc,
            tipdoc,
            entidad,
            rut,
        } = data[0];

        const equiposHTML = data
            .map(
                (item, index) => `
            <tr>
                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        text-align:center;
                        font-size:13px;
                        color:#555;
                    "
                >
                    ${index + 1}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:14px;
                        font-weight:600;
                        color:#1b1c1d;
                    "
                >
                    ${item.tipo || "-"}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:14px;
                        color:#555;
                    "
                >
                    ${item.marca || "-"}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:14px;
                        color:#555;
                    "
                >
                    ${item.modelo || "-"}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:13px;
                        color:#008080;
                        font-weight:600;
                        white-space:nowrap;
                    "
                >
                    ${item.serie || "-"}
                </td>
            </tr>
        `
            )
            .join("");

        return `
    <div
        style="
            width:100%;
            background:#f4f6f8;
            padding:20px 10px;
            font-family:Arial,sans-serif;
            color:#333;
            box-sizing:border-box;
        "
    >

        <table
            width="100%"
            cellpadding="0"
            cellspacing="0"
            border="0"
            style="
                max-width:640px;
                margin:auto;
                background:#ffffff;
                border-radius:14px;
                overflow:hidden;
                border:1px solid #e5e7eb;
                box-shadow:0 4px 18px rgba(0,0,0,0.05);
            "
        >

            <!-- HEADER -->

            <tr>
                <td
                    style="
                        background:linear-gradient(135deg,#008080,#00a3a3);
                        padding:30px 25px;
                        text-align:center;
                        color:white;
                    "
                >

                    <div
                        style="
                            font-size:28px;
                            margin-bottom:10px;
                        "
                    >
                        🚚
                    </div>

                    <h1
                        style="
                            margin:0;
                            font-size:24px;
                            font-weight:700;
                            line-height:1.2;
                        "
                    >
                        Salida de Bodega
                    </h1>

                    <p
                        style="
                            margin:10px 0 0 0;
                            opacity:0.95;
                            font-size:15px;
                        "
                    >
                        Equipos en tránsito
                    </p>

                </td>
            </tr>

            <!-- BODY -->

            <tr>
                <td style="padding:25px;">

                    <!-- INFO DOCUMENTO -->

                    <div
                        style="
                            background:#f8fafc;
                            border:1px solid #e5e7eb;
                            border-radius:12px;
                            padding:18px;
                            margin-bottom:25px;
                        "
                    >

                        <div
                            style="
                                font-size:17px;
                                font-weight:700;
                                color:#008080;
                                margin-bottom:15px;
                            "
                        >
                            Información del Documento
                        </div>

                        <table
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                        >
                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Tipo Salida
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${tipoinout || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    N° Documento
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${numdoc || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Tipo Documento
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${tipdoc || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Entidad
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${entidad || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Rut
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${rut || "-"}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <!-- EQUIPOS -->

                    <div
                        style="
                            font-size:17px;
                            font-weight:700;
                            color:#008080;
                            margin-bottom:15px;
                        "
                    >
                        Equipos trasladados
                    </div>

                    <div
                        style="
                            overflow-x:auto;
                            border:1px solid #ececec;
                            border-radius:12px;
                        "
                    >

                        <table
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                            style="
                                border-collapse:collapse;
                                min-width:520px;
                            "
                        >

                            <thead>

                                <tr
                                    style="
                                        background:#f8fafc;
                                    "
                                >

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:center;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        #
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Tipo
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Marca
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Modelo
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Serie
                                    </th>

                                </tr>

                            </thead>

                            <tbody>
                                ${equiposHTML}
                            </tbody>

                        </table>

                    </div>

                    <!-- ALERTA -->

                    <div
                        style="
                            margin-top:25px;
                            background:#fff8e1;
                            border-left:5px solid #ffb300;
                            border-radius:10px;
                            padding:16px;
                            font-size:14px;
                            line-height:1.5;
                            color:#6b5b00;
                        "
                    >
                        <strong>Importante:</strong><br/>
                        Los equipos se encuentran actualmente en tránsito y
                        pendientes de confirmación por el destinatario.
                    </div>

                </td>
            </tr>

            <!-- FOOTER -->

            <tr>
                <td
                    style="
                        background:#fafafa;
                        border-top:1px solid #ececec;
                        padding:18px;
                        text-align:center;
                        font-size:12px;
                        color:#888;
                    "
                >
                    Este correo fue generado automáticamente por LogisticMed.
                </td>
            </tr>

        </table>

    </div>
    `;
    };

    // Agregar una nueva cabecera
    const nuevo = () => {
        setCabeceraId(null);

        setNumDoc('');
        setNomTipDoc('');

        setDate(new Date());

        setNomTipoOut('');

        setRut('');
        setEntidad('');

        setNumSerie('');

        setCorreo('');
        setPatente('');

        setDescripcion('');

        setConfirmar(false);

        setBtnGuardar(false);
        setBtnAgregar(true);
        setBtnConfirmar(true);
        setBtnNuevo(true);

        setCabeceraMinimizada(false);
        setDetalleMinimizado(true);

        setDataSalida([]);

        setUltimoItemAgregadoId(null);

        almacenar.current = [];
        salidaid.current = [];

        setFlag((prev) => !prev);
    };

    const abrirBuscadorEquipos = async () => {
        if (!users) return;

        if (!rut) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: "Debe seleccionar un rut antes de buscar equipos",
            });
            return;
        }

        if (!nomTipoOut) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: "Debe seleccionar un tipo de salida",
            });
            return;
        }

        setModalBuscarEquipo(true);
        setTextoBusquedaEquipo("");
        setCargandoBusqueda(true);

        try {
            let idsValidos = [];

            if (nomTipoOut === "PACIENTE") {
                // Salida a paciente: equipos disponibles en bodega
                idsValidos = status
                    .filter((st) => st.status === "BODEGA")
                    .map((st) => st.id);
            }

            else if (nomTipoOut === "RETIRO PACIENTE") {
                // Retiro paciente: equipos que están en ese paciente
                idsValidos = status
                    .filter(
                        (st) =>
                            st.status === "PACIENTE" &&
                            st.r_destino === rut
                    )
                    .map((st) => st.id);
            }

            else if (nomTipoOut === "RETIRO SERVICIO TECNICO") {
                // Retiro ST: equipos que están en ese proveedor/ST
                idsValidos = status
                    .filter(
                        (st) =>
                            st.status === "SERVICIO TECNICO" &&
                            st.r_destino === rut
                    )
                    .map((st) => st.id);
            }

            else if (nomTipoOut === "DEVOLUCION A PROVEEDOR") {
                // Devolución proveedor:
                // equipos comprados o arrendados a ese proveedor + actualmente en bodega
                const qEntradasProveedor = query(
                    collection(db, "entradas"),
                    where("emp_id", "==", users.emp_id),
                    where("rut", "==", rut),
                    where("tipoinout", "in", ["COMPRA", "ARRIENDO"])
                );

                const snapEntradasProveedor = await getDocs(qEntradasProveedor);
                console.log("snapEntradasProveedor", snapEntradasProveedor.docs.map(doc => doc.data()))
                const idsProveedor = snapEntradasProveedor.docs
                    .map((docu) => docu.data().eq_id)
                    .filter(Boolean);

                const idsBodega = status
                    .filter((st) => st.status === "BODEGA")
                    .map((st) => st.id);

                idsValidos = idsProveedor.filter((id) =>
                    idsBodega.includes(id)
                );
            }

            else {
                // Otros tipos: equipos en bodega
                idsValidos = status
                    .filter((st) => st.status === "BODEGA")
                    .map((st) => st.id);
            }

            const qEquipos = query(
                collection(db, "equipos"),
                where("emp_id", "==", users.emp_id)
            );

            const snapEquipos = await getDocs(qEquipos);

            const equipos = snapEquipos.docs
                .map((docu) => ({
                    ...docu.data(),
                    id: docu.id,
                }))
                .filter((eq) => idsValidos.includes(eq.id));

            setEquiposBusqueda(equipos);
        } catch (error) {
            console.log("Error buscador equipos:", error);

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: "Error al cargar equipos",
            });
        } finally {
            setCargandoBusqueda(false);
        }
    };

    const equiposFiltrados = equiposBusqueda.filter(eq => {

        const texto = textoBusquedaEquipo.toLowerCase();

        return (
            eq.id?.toLowerCase().includes(texto) ||
            eq.serie?.toLowerCase().includes(texto) ||
            eq.tipo?.toLowerCase().includes(texto) ||
            eq.marca?.toLowerCase().includes(texto) ||
            eq.modelo?.toLowerCase().includes(texto) ||
            eq.rfid?.toLowerCase().includes(texto)
        );
    });

    const seleccionarEquipoBusqueda = async (equipo) => {
        setModalBuscarEquipo(false);
        setTextoBusquedaEquipo("");
        setEquiposBusqueda([]);

        await handleSubmit(
            {
                preventDefault: () => { },
            },
            equipo
        );
    };

    useEffect(() => {
        if (dataSalida.length > 0 && detalleTablaRef.current) {
            detalleTablaRef.current.scrollTo({
                top: detalleTablaRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [dataSalida.length]);

    useEffect(() => {
        consultarUltimosConfirmados();
        consultarCab();
        getEmpresa();
        transportista();
        getUsuarios();
        getAlertasSalidas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users])

    useEffect(() => {
        getStatus();
        consultarCab();
        consultarOut();
        transportista();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag, users, cabeceraId]);


    useEffect(() => {
        if (nomTipoOut === 'PACIENTE' || nomTipoOut === 'RETIRO PACIENTE') {
            consultarClientes();
        } else {
            consultarProv();
        }
        // if (dataSalida.length > 0) setBtnConfirmar(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nomTipoOut])

    return (
        <Container
            fluid
            style={{
                maxWidth: 1400,
                margin: "0 auto",
                padding: "24px 28px 40px",
                background: "#f8fafc",
                minHeight: "100vh",
            }}
        >
            {/* =====================================================
            HEADER
        ===================================================== */}

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 16,
                    marginBottom: 20,
                    flexWrap: "wrap",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                    }}
                >
                    <div
                        style={{
                            width: 48,
                            height: 48,
                            borderRadius: 10,
                            background: "#e6f7f8",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <Icon
                            name="sign-out alternate"
                            style={{
                                margin: 0,
                                fontSize: 22,
                                color: "#0d9da5",
                            }}
                        />
                    </div>

                    <div>
                        <div
                            style={{
                                color: "#172b4d",
                                fontSize: 24,
                                fontWeight: 700,
                                lineHeight: 1.2,
                            }}
                        >
                            Salida de Equipos
                        </div>

                        <div
                            style={{
                                color: "#6b778c",
                                fontSize: 14,
                                marginTop: 4,
                            }}
                        >
                            Gestión de movimientos y despacho de equipos
                        </div>
                    </div>
                </div>

                {confirmar && (
                    <Label
                        basic
                        style={{
                            borderColor: "#b3e5e8",
                            color: "#0d9da5",
                            background: "#f1fbfb",
                            borderRadius: 6,
                            padding: "9px 12px",
                        }}
                    >
                        <Icon name="file alternate outline" />
                        Documento en proceso
                    </Label>
                )}
            </div>

            {/* =====================================================
            CABECERA DOCUMENTO
        ===================================================== */}

            <Segment
                style={{
                    background: "#ffffff",
                    border:
                        seccionActiva === "CABECERA"
                            ? "2px solid #2185d0"
                            : "1px solid #e5e9ef",
                    borderRadius: 8,
                    boxShadow:
                        seccionActiva === "CABECERA"
                            ? "0 0 0 3px rgba(33,133,208,0.08)"
                            : "0 1px 3px rgba(9,30,66,0.08)",
                    padding: 0,
                    marginBottom: 18,
                    overflow: "visible",
                }}
            >
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: cabeceraMinimizada
                            ? "none"
                            : "1px solid #e5e9ef",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 9,
                        }}
                    >
                        <Icon
                            name="file alternate outline"
                            style={{
                                color: "#2185d0",
                                fontSize: 18,
                                margin: 0,
                            }}
                        />

                        <span
                            style={{
                                color: "#253858",
                                fontSize: 16,
                                fontWeight: 700,
                            }}
                        >
                            Cabecera del Documento
                        </span>
                        {seccionActiva === "CABECERA" && (
                            <Label
                                size="tiny"
                                style={{
                                    marginLeft: 8,
                                    background: "#eaf4fb",
                                    color: "#2185d0",
                                    border: "1px solid #b8d7f0",
                                }}
                            >
                                Editando
                            </Label>
                        )}
                    </div>

                    {confirmar && (
                        <Button
                            size="mini"
                            basic
                            onClick={() =>
                                setCabeceraMinimizada(
                                    !cabeceraMinimizada
                                )
                            }
                            style={{
                                color: "#0d9da5",
                                borderColor: "#b3e5e8",
                            }}
                        >
                            <Icon
                                name={
                                    cabeceraMinimizada
                                        ? "angle down"
                                        : "angle up"
                                }
                            />

                            {cabeceraMinimizada
                                ? "Ver cabecera"
                                : "Minimizar"}
                        </Button>
                    )}
                </div>

                {cabeceraMinimizada ? (
                    <div
                        style={{
                            padding: "12px 18px 14px",
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            flexWrap: "wrap",
                        }}
                    >
                        <Label
                            basic
                            style={{
                                borderColor: "#dfe3e8",
                                color: "#344563",
                                background: "#f8fafc",
                            }}
                        >
                            {nomTipDoc || "-"} N° {numDoc || "-"}
                        </Label>

                        <span
                            style={{
                                color: "#6b778c",
                                fontSize: 13,
                            }}
                        >
                            {nomTipoOut || "-"} · {rut || "-"} ·{" "}
                            {entidad || "-"}
                        </span>
                    </div>
                ) : (
                    <div style={{ padding: "18px" }}>
                        <Form
                            onFocusCapture={() => setSeccionActiva("CABECERA")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                }
                            }}
                        >
                            <div style={sectionTitleStyle}>
                                <Icon
                                    name="file alternate outline"
                                    style={{ color: "#2185d0" }}
                                />
                                Documento
                            </div>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>N° de Documento</label>

                                    <Input
                                        disabled={confirmar}
                                        type="number"
                                        name="NumDoc"
                                        placeholder="Ingrese N° Documento"
                                        value={numDoc}
                                        onChange={(ev) => {
                                            if (
                                                /^[1-9]\d*$/.test(
                                                    ev.target.value
                                                )
                                            ) {
                                                setNumDoc(
                                                    ev.target.value
                                                );
                                            } else {
                                                cambiarEstadoAlerta(
                                                    true
                                                );

                                                cambiarAlerta({
                                                    tipo: "error",
                                                    mensaje:
                                                        "Por favor ingrese un numero positivo",
                                                });

                                                setNumDoc("");
                                            }
                                        }}
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>
                                        Tipo de Documento
                                    </label>

                                    <Dropdown
                                        fluid
                                        selection
                                        search
                                        disabled={confirmar}
                                        placeholder="Selecciona Opción"
                                        value={nomTipDoc || ""}
                                        onChange={(e, { value }) =>
                                            setNomTipDoc(value)
                                        }
                                        options={TipDocOut.map(
                                            (d) => ({
                                                key: d.key,
                                                text: d.text,
                                                value: d.text,
                                            })
                                        )}
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>Fecha Salida</label>

                                    <div className="ui fluid input">
                                        <DatePicker
                                            selected={date}
                                            openToDate={
                                                date || new Date()
                                            }
                                            onChange={(fecha) => {
                                                if (!fecha) return;

                                                const ahora =
                                                    new Date();

                                                fecha.setHours(
                                                    ahora.getHours(),
                                                    ahora.getMinutes(),
                                                    ahora.getSeconds(),
                                                    ahora.getMilliseconds()
                                                );

                                                setDate(
                                                    new Date(fecha)
                                                );
                                            }}
                                            locale={es}
                                            dateFormat="dd/MM/yyyy"
                                            todayButton="Hoy"
                                            shouldCloseOnSelect
                                            placeholderText="Seleccione fecha"
                                            disabled={confirmar}
                                            minDate={fechaMinima}
                                            maxDate={fechaMaxima}
                                            wrapperClassName="datePickerFullWidth"
                                        />
                                    </div>
                                </Form.Field>
                            </Form.Group>

                            <div
                                style={{
                                    ...sectionTitleStyle,
                                    marginTop: 14,
                                }}
                            >
                                <Icon
                                    name="exchange"
                                    style={{ color: "#f2711c" }}
                                />
                                Destino del movimiento
                            </div>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Tipo Salida</label>

                                    <Dropdown
                                        fluid
                                        selection
                                        search
                                        disabled={confirmar}
                                        placeholder="Selecciona Opción"
                                        value={nomTipoOut || ""}
                                        onChange={(e, { value }) =>
                                            setNomTipoOut(value)
                                        }
                                        options={TipoOut.map(
                                            (d) => ({
                                                key: d.key,
                                                text: d.text,
                                                value: d.text,
                                            })
                                        )}
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>{nomRut.current}</label>

                                    <BuscadorInput
                                        items={x}
                                        onSelectItem={
                                            handleSelectItem
                                        }
                                        limpiaFormCte={
                                            limpiaFormCte
                                        }
                                        confirmar={confirmar}
                                        rut={rut}
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>Nombre</label>

                                    <Input
                                        value={entidad}
                                        disabled
                                        icon={
                                            <Icon
                                                name="building outline"
                                                style={{
                                                    color: "#0d9da5",
                                                }}
                                            />
                                        }
                                    />
                                </Form.Field>
                            </Form.Group>

                            <div
                                style={{
                                    ...sectionTitleStyle,
                                    marginTop: 14,
                                }}
                            >
                                <Icon
                                    name="truck"
                                    style={{ color: "#6435c9" }}
                                />
                                Transporte
                            </div>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>
                                        Correo Transportista
                                    </label>

                                    <Dropdown
                                        fluid
                                        selection
                                        search
                                        disabled={confirmar}
                                        placeholder="Selecciona transportista"
                                        value={correo || ""}
                                        onChange={(e, { value }) =>
                                            setCorreo(value)
                                        }
                                        options={transport.map(
                                            (d) => ({
                                                key: d.id,
                                                text: `${d.nombre} ${d.apellido} - ${d.correo}`,
                                                value: d.correo,
                                            })
                                        )}
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>
                                        Patente Vehículo
                                    </label>

                                    <Input
                                        disabled={confirmar}
                                        type="text"
                                        placeholder="Ingrese patente"
                                        name="patente"
                                        value={patente}
                                        onChange={(ev) =>
                                            setPatente(
                                                ev.target.value.toUpperCase()
                                            )
                                        }
                                        icon={
                                            <Icon
                                                name="car"
                                                style={{
                                                    color: "#f2711c",
                                                }}
                                            />
                                        }
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Field>
                                <label>Descripción</label>

                                <Form.TextArea
                                    disabled={confirmar}
                                    placeholder="Ingrese descripción o detalles adicionales"
                                    value={descripcion}
                                    onChange={(e) =>
                                        setDescripcion(
                                            e.target.value
                                        )
                                    }
                                    style={{
                                        minHeight: 75,
                                        resize: "vertical",
                                    }}
                                />
                            </Form.Field>

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    justifyContent: "flex-end",
                                    flexWrap: "wrap",
                                    marginTop: 14,
                                }}
                            >
                                <Button
                                    basic
                                    onClick={nuevo}
                                    disabled={btnNuevo}
                                >
                                    <Icon name="add" />
                                    Nuevo
                                </Button>

                                <Button
                                    primary
                                    loading={guardandoCabecera}
                                    onClick={addCabeceraIn}
                                    disabled={
                                        btnGuardar ||
                                        guardandoCabecera
                                    }
                                >
                                    <Icon name="save" />
                                    Guardar cabecera
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}
            </Segment>

            {/* =====================================================
            DETALLE
        ===================================================== */}

            <Segment
                style={{
                    background: "#ffffff",
                    border:
                        seccionActiva === "DETALLE"
                            ? "2px solid #f2711c"
                            : "1px solid #e5e9ef",
                    borderRadius: 8,
                    boxShadow:
                        seccionActiva === "DETALLE"
                            ? "0 0 0 3px rgba(242,113,28,0.08)"
                            : "0 1px 3px rgba(9,30,66,0.08)",
                    padding: 0,
                    marginBottom: 18,
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: detalleMinimizado
                            ? "none"
                            : "1px solid #e5e9ef",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 9,
                        }}
                    >
                        <Icon
                            name="boxes"
                            style={{
                                color: "#f2711c",
                                fontSize: 18,
                                margin: 0,
                            }}
                        />

                        <span
                            style={{
                                color: "#253858",
                                fontSize: 16,
                                fontWeight: 700,
                            }}
                        >
                            Detalle de Equipos
                        </span>
                        {seccionActiva === "DETALLE" && (
                            <Label
                                size="tiny"
                                style={{
                                    marginLeft: 8,
                                    background: "#fff3eb",
                                    color: "#f2711c",
                                    border: "1px solid #f7c7a7",
                                }}
                            >
                                Agregando equipos
                            </Label>
                        )}

                        <Label
                            circular
                            style={{
                                background: "#f4f5f7",
                                color: "#42526e",
                                marginLeft: 4,
                            }}
                        >
                            {dataSalida.length}
                        </Label>
                    </div>

                    {confirmar && (
                        <Button
                            size="mini"
                            basic
                            onClick={() =>
                                setDetalleMinimizado(
                                    !detalleMinimizado
                                )
                            }
                            style={{
                                color: "#0d9da5",
                                borderColor: "#b3e5e8",
                            }}
                        >
                            <Icon
                                name={
                                    detalleMinimizado
                                        ? "angle down"
                                        : "angle up"
                                }
                            />

                            {detalleMinimizado
                                ? "Ver detalle"
                                : "Minimizar"}
                        </Button>
                    )}
                </div>

                {detalleMinimizado ? (
                    <div
                        style={{
                            padding: "12px 18px 14px",
                        }}
                    >
                        <Label
                            basic
                            color={
                                dataSalida.length > 0
                                    ? "green"
                                    : "grey"
                            }
                        >
                            <Icon name="list" />
                            {dataSalida.length} equipo(s)
                            agregado(s)
                        </Label>
                    </div>
                ) : (
                    <div style={{ padding: "18px" }}>
                        <Form

                            onFocusCapture={() => setSeccionActiva("DETALLE")}
                        >
                            <div style={sectionTitleStyle}>
                                <Icon
                                    name="barcode"
                                    style={{ color: "#0d9da5" }}
                                />
                                Selección de equipo
                            </div>

                            <Form.Group>
                                <Form.Field width={12}>
                                    <label>
                                        Serie / ID del Equipo
                                    </label>

                                    <Input
                                        fluid
                                        type="text"
                                        name="serie"
                                        placeholder="Escanee o ingrese Serie / ID"
                                        value={numSerie}
                                        onChange={(e) =>
                                            setNumSerie(
                                                e.target.value
                                            )
                                        }
                                        onKeyDown={detectar}
                                        icon={
                                            <Icon
                                                name="barcode"
                                                style={{
                                                    color: "#6b778c",
                                                }}
                                            />
                                        }
                                    />
                                </Form.Field>

                                <Form.Field
                                    width={4}
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            gap: 8,
                                        }}
                                    >
                                        <Button
                                            fluid
                                            basic
                                            type="button"
                                            onClick={
                                                abrirBuscadorEquipos
                                            }
                                        >
                                            <Icon
                                                name="search"
                                                style={{
                                                    color: "#0d9da5",
                                                }}
                                            />
                                            Buscar
                                        </Button>

                                        <Button
                                            icon
                                            color="teal"
                                            type="button"
                                            loading={
                                                guardandoDetalle
                                            }
                                            onClick={handleSubmit}
                                            disabled={
                                                btnAgregar ||
                                                guardandoDetalle
                                            }
                                            title="Agregar equipo"
                                        >
                                            <Icon name="plus" />
                                        </Button>
                                    </div>
                                </Form.Field>
                            </Form.Group>
                        </Form>

                        <div
                            ref={detalleTablaRef}
                            style={{
                                maxHeight: 370,
                                overflowY: "auto",
                                overflowX: "auto",
                                marginTop: 14,
                                border: "1px solid #e5e9ef",
                                borderRadius: 6,
                            }}
                        >
                            <Table
                                compact="very"
                                unstackable
                                style={{
                                    margin: 0,
                                    minWidth: 750,
                                    border: "none",
                                }}
                            >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell
                                            width={1}
                                            textAlign="center"
                                            style={stickyTh}
                                        >
                                            N°
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={stickyTh}
                                        >
                                            Equipo
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={stickyTh}
                                        >
                                            N° Serie
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            width={1}
                                            textAlign="center"
                                            style={stickyTh}
                                        >
                                            Acción
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {dataSalida.length === 0 ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="4"
                                                textAlign="center"
                                                style={{
                                                    padding: 28,
                                                    color: "#8993a4",
                                                }}
                                            >
                                                <Icon
                                                    name="boxes"
                                                    disabled
                                                />
                                                No hay equipos
                                                agregados
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : (
                                        dataSalida.map(
                                            (item, index) => (
                                                <Table.Row
                                                    key={item.id}
                                                    positive={
                                                        ultimoItemAgregadoId ===
                                                        item.eq_id
                                                    }
                                                >
                                                    <Table.Cell textAlign="center">
                                                        {index + 1}
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        <div
                                                            style={{
                                                                fontWeight: 600,
                                                                color: "#344563",
                                                            }}
                                                        >
                                                            {item.tipo ||
                                                                "-"}
                                                        </div>

                                                        <div
                                                            style={{
                                                                color: "#8993a4",
                                                                fontSize: 12,
                                                                marginTop: 2,
                                                            }}
                                                        >
                                                            {[
                                                                item.marca,
                                                                item.modelo,
                                                            ]
                                                                .filter(
                                                                    Boolean
                                                                )
                                                                .join(
                                                                    " · "
                                                                )}
                                                        </div>
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        {item.serie ||
                                                            "-"}
                                                    </Table.Cell>

                                                    <Table.Cell textAlign="center">
                                                        <Button
                                                            basic
                                                            negative
                                                            icon
                                                            size="mini"
                                                            onClick={() =>
                                                                handleDelete(
                                                                    item.id
                                                                )
                                                            }
                                                            title="Eliminar Item"
                                                        >
                                                            <Icon name="trash alternate" />
                                                        </Button>
                                                    </Table.Cell>
                                                </Table.Row>
                                            )
                                        )
                                    )}
                                </Table.Body>
                            </Table>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: 14,
                            }}
                        >
                            <Button
                                color="green"
                                loading={confirmandoDocumento}
                                onClick={() => {
                                    if (dataSalida.length === 0) {
                                        mostrarError(
                                            "Debe agregar al menos un equipo antes de confirmar el documento."
                                        );
                                        return;
                                    }

                                    setShowConfirmarDocumento(true);
                                }}
                                disabled={
                                    btnConfirmar ||
                                    confirmandoDocumento ||
                                    dataSalida.length === 0
                                }
                                title={
                                    dataSalida.length === 0
                                        ? "Debe agregar al menos un equipo antes de confirmar"
                                        : "Confirmar documento de salida"
                                }
                            >
                                <Icon name="check" />
                                Confirmar Documento
                            </Button>
                        </div>
                    </div>
                )}
            </Segment>

            {/* =====================================================
            DOCUMENTOS PENDIENTES
        ===================================================== */}

            <Segment
                style={{
                    background: "#ffffff",
                    border: "1px solid #e5e9ef",
                    borderRadius: 8,
                    boxShadow: "0 1px 3px rgba(9,30,66,0.08)",
                    padding: 0,
                    marginBottom: 18,
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: "1px solid #e5e9ef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 9,
                        }}
                    >
                        <Icon
                            name="clock outline"
                            style={{
                                color: "#0d9da5",
                                fontSize: 18,
                                margin: 0,
                            }}
                        />

                        <span
                            style={{
                                color: "#253858",
                                fontSize: 16,
                                fontWeight: 700,
                            }}
                        >
                            Documentos por Confirmar
                        </span>
                    </div>

                    <Label
                        basic
                        style={{
                            color: "#6b778c",
                            borderColor: "#dfe3e8",
                        }}
                    >
                        {merge.length}
                    </Label>
                </div>

                <div
                    style={{
                        maxHeight: 390,
                        overflowY: "auto",
                        overflowX: "auto",
                    }}
                >
                    <Table
                        compact="very"
                        unstackable
                        style={{
                            margin: 0,
                            minWidth: 1050,
                            border: "none",
                        }}
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    width={1}
                                    textAlign="center"
                                    style={stickyTh}
                                >
                                    N°
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    N° Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Fecha
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Salida
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Rut
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Entidad
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    width={1}
                                    textAlign="center"
                                    style={stickyTh}
                                >
                                    Abrir
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    width={1}
                                    textAlign="center"
                                    style={stickyTh}
                                >
                                    Anular
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {merge.length === 0 ? (
                                <Table.Row>
                                    <Table.Cell
                                        colSpan="9"
                                        textAlign="center"
                                        style={{
                                            padding: 28,
                                            color: "#8993a4",
                                        }}
                                    >
                                        No hay documentos pendientes
                                        de confirmación.
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                merge.map((item, index) => (
                                    <Table.Row key={item.id}>
                                        <Table.Cell textAlign="center">
                                            {index + 1}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.tipdoc}
                                        </Table.Cell>

                                        <Table.Cell>
                                            <strong>
                                                {item.numdoc}
                                            </strong>
                                        </Table.Cell>

                                        <Table.Cell>
                                            {formatearFecha(
                                                item.date
                                            )}
                                        </Table.Cell>

                                        <Table.Cell>
                                            <Label
                                                basic
                                                size="tiny"
                                                style={{
                                                    color: "#42526e",
                                                }}
                                            >
                                                {item.tipoinout}
                                            </Label>
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.rut}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {item.entidad}
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Button
                                                basic
                                                icon
                                                size="mini"
                                                title="Cargar documento"
                                                style={{
                                                    color: "#2185d0",
                                                    borderColor:
                                                        "#b8d7f0",
                                                }}
                                                onClick={() => {
                                                    setCabeceraId(
                                                        item.id
                                                    );

                                                    setNumDoc(
                                                        item.numdoc
                                                    );

                                                    setNomTipDoc(
                                                        item.tipdoc
                                                    );

                                                    setNomTipoOut(
                                                        item.tipoinout
                                                    );

                                                    setRut(
                                                        item.rut
                                                    );

                                                    setEntidad(
                                                        item.entidad
                                                    );

                                                    fechaDate(
                                                        item.date
                                                    );

                                                    setCorreo(
                                                        item.correo ||
                                                        ""
                                                    );

                                                    setPatente(
                                                        item.patente ||
                                                        ""
                                                    );

                                                    setDescripcion(
                                                        item.descripcion ||
                                                        ""
                                                    );

                                                    setBtnGuardar(
                                                        true
                                                    );

                                                    setBtnAgregar(
                                                        false
                                                    );

                                                    setConfirmar(
                                                        true
                                                    );

                                                    setBtnNuevo(
                                                        false
                                                    );

                                                    setBtnConfirmar(
                                                        false
                                                    );

                                                    setCabeceraMinimizada(
                                                        true
                                                    );

                                                    setDetalleMinimizado(
                                                        false
                                                    );

                                                    setFlag(
                                                        (prev) =>
                                                            !prev
                                                    );
                                                }}
                                            >
                                                <Icon name="arrow up" />
                                            </Button>
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Button
                                                basic
                                                negative
                                                icon
                                                size="mini"
                                                onClick={() =>
                                                    handleAnular(
                                                        item.id
                                                    )
                                                }
                                                title="Anular Documento"
                                            >
                                                <Icon name="cancel" />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            )}
                        </Table.Body>
                    </Table>
                </div>
            </Segment>

            {/* =====================================================
            ÚLTIMOS CONFIRMADOS
        ===================================================== */}

            <Segment
                style={{
                    background: "#ffffff",
                    border: "1px solid #e5e9ef",
                    borderRadius: 8,
                    boxShadow: "0 1px 3px rgba(9,30,66,0.08)",
                    padding: 0,
                    marginBottom: 18,
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        padding: "14px 18px",
                        borderBottom: "1px solid #e5e9ef",
                        display: "flex",
                        alignItems: "center",
                        gap: 9,
                    }}
                >
                    <Icon
                        name="check circle"
                        style={{
                            color: "#21ba45",
                            fontSize: 18,
                            margin: 0,
                        }}
                    />

                    <div>
                        <div
                            style={{
                                color: "#253858",
                                fontSize: 16,
                                fontWeight: 700,
                            }}
                        >
                            Últimos Documentos Confirmados
                        </div>

                        <div
                            style={{
                                fontSize: 12,
                                color: "#8993a4",
                                marginTop: 2,
                            }}
                        >
                            Últimos 5 movimientos confirmados
                        </div>
                    </div>
                </div>

                <div style={{ overflowX: "auto" }}>
                    <Table
                        compact="very"
                        unstackable
                        style={{
                            margin: 0,
                            minWidth: 1000,
                            border: "none",
                        }}
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    width={1}
                                    textAlign="center"
                                    style={stickyTh}
                                >
                                    N°
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    N° Documento
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Fecha
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Tipo Salida
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Rut
                                </Table.HeaderCell>

                                <Table.HeaderCell style={stickyTh}>
                                    Entidad
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    width={1}
                                    textAlign="center"
                                    style={stickyTh}
                                >
                                    PDF
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {ultimosConfirmados.length ===
                                0 ? (
                                <Table.Row>
                                    <Table.Cell
                                        colSpan="8"
                                        textAlign="center"
                                        style={{
                                            padding: 28,
                                            color: "#8993a4",
                                        }}
                                    >
                                        No hay documentos
                                        confirmados recientemente.
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                ultimosConfirmados.map(
                                    (item, index) => (
                                        <Table.Row key={item.id}>
                                            <Table.Cell textAlign="center">
                                                {index + 1}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.tipdoc}
                                            </Table.Cell>

                                            <Table.Cell>
                                                <strong>
                                                    {
                                                        item.numdoc
                                                    }
                                                </strong>
                                            </Table.Cell>

                                            <Table.Cell>
                                                {formatearFecha(
                                                    item.date
                                                )}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.tipoinout}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.rut}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.entidad}
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Button
                                                    basic
                                                    negative
                                                    icon
                                                    size="mini"
                                                    loading={
                                                        cargandoPDFId ===
                                                        item.id
                                                    }
                                                    disabled={
                                                        cargandoPDFId !==
                                                        null
                                                    }
                                                    onClick={() =>
                                                        verPDFDocumento(
                                                            item
                                                        )
                                                    }
                                                    title="Ver PDF"
                                                >
                                                    <Icon name="file pdf" />
                                                </Button>
                                            </Table.Cell>
                                        </Table.Row>
                                    )
                                )
                            )}
                        </Table.Body>
                    </Table>
                </div>
            </Segment>

            {/* =====================================================
    VISOR PDF DOCUMENTO DE SALIDA
===================================================== */}

            {modalPDF && cabeceraPDF && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "96vw",
                            maxWidth: 1250,

                            // Espacio para navbar de LogisticMed
                            height: "calc(100vh - 125px)",
                            maxHeight: 850,
                            marginTop: 70,

                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.24)",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "14px 18px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 15,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    minWidth: 0,
                                }}
                            >
                                <div
                                    style={{
                                        width: 42,
                                        height: 42,
                                        minWidth: 42,
                                        borderRadius: 8,
                                        background: "#ffebe6",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Icon
                                        name="file pdf"
                                        style={{
                                            margin: 0,
                                            color: "#db2828",
                                            fontSize: 19,
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            color: "#172b4d",
                                            fontWeight: 700,
                                            fontSize: 17,
                                        }}
                                    >
                                        Documento de Salida
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 6,
                                            flexWrap: "wrap",
                                            marginTop: 4,
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        <span>
                                            {cabeceraPDF.tipdoc || "Documento"}
                                        </span>

                                        <span>•</span>

                                        <strong
                                            style={{
                                                color: "#253858",
                                            }}
                                        >
                                            N° {cabeceraPDF.numdoc}
                                        </strong>

                                        {cabeceraPDF.entidad && (
                                            <>
                                                <span>•</span>
                                                <span>
                                                    {cabeceraPDF.entidad}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <Button
                                basic
                                icon
                                labelPosition="left"
                                type="button"
                                onClick={() => {
                                    setModalPDF(false);
                                    setCabeceraPDF(null);
                                    setDetallePDF([]);
                                }}
                                style={{
                                    flexShrink: 0,
                                    borderRadius: 6,
                                    color: "#526273",
                                }}
                            >
                                <Icon
                                    name="close"
                                    style={{
                                        color: "#db2828",
                                    }}
                                />
                                Cerrar
                            </Button>
                        </div>

                        {/* INFO */}
                        <div
                            style={{
                                padding: "9px 18px",
                                background: "#f8fafc",
                                borderBottom: "1px solid #edf0f4",
                                display: "flex",
                                alignItems: "center",
                                gap: 16,
                                flexWrap: "wrap",
                                fontSize: 12,
                                color: "#6b778c",
                            }}
                        >
                            <span>
                                <Icon
                                    name="calendar alternate outline"
                                    style={{ color: "#2185d0" }}
                                />
                                {formatearFecha(cabeceraPDF.date)}
                            </span>

                            <span>
                                <Icon
                                    name="exchange"
                                    style={{ color: "#f2711c" }}
                                />
                                {cabeceraPDF.tipoinout || "-"}
                            </span>

                            <span>
                                <Icon
                                    name="boxes"
                                    style={{ color: "#0d9da5" }}
                                />
                                {detallePDF.length} equipo(s)
                            </span>

                            {cabeceraPDF.rut && (
                                <span>
                                    <Icon
                                        name="building outline"
                                        style={{ color: "#6435c9" }}
                                    />
                                    {cabeceraPDF.rut}
                                </span>
                            )}
                        </div>

                        {/* PDF */}
                        <div
                            style={{
                                flex: 1,
                                minHeight: 0,
                                overflow: "hidden",
                                background: "#e9edf2",
                                padding: 10,
                            }}
                        >
                            <PDFViewer
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    border: "1px solid #d7dde5",
                                    borderRadius: 7,
                                    background: "#ffffff",
                                }}
                            >
                                <DocumentoSalidaPDF
                                    numDoc={cabeceraPDF.numdoc}
                                    nomTipDoc={cabeceraPDF.tipdoc}
                                    date={formatearFecha(cabeceraPDF.date)}
                                    nomTipoOut={cabeceraPDF.tipoinout}
                                    rut={cabeceraPDF.rut}
                                    entidad={cabeceraPDF.entidad}
                                    correo={cabeceraPDF.correo}
                                    patente={cabeceraPDF.patente}
                                    descripcion={cabeceraPDF.descripcion}
                                    dataSalida={detallePDF}
                                />
                            </PDFViewer>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* ===================== ALERTAS + CONFIRMACIONES ===================== */}
            <Alertas
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />

            {/* =====================================================
    MODAL ELIMINAR EQUIPO
===================================================== */}

            {showConfirmation && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 460,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#fff3eb",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="trash alternate"
                                    style={{
                                        margin: 0,
                                        color: "#f2711c",
                                        fontSize: 18,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                    }}
                                >
                                    Eliminar equipo del documento
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Se eliminará únicamente este equipo de la salida.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}
                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    color: "#344563",
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Desea quitar este equipo del documento de salida?
                            </div>

                            {(() => {
                                const equipo = dataSalida.find(
                                    (d) => d.id === itemDelete
                                );

                                return equipo ? (
                                    <div
                                        style={{
                                            background: "#f8fafc",
                                            border: "1px solid #e5e9ef",
                                            borderRadius: 7,
                                            padding: "12px 14px",
                                            marginBottom: 16,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#6b778c",
                                                    fontSize: 12,
                                                }}
                                            >
                                                Equipo
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                    fontSize: 13,
                                                    textAlign: "right",
                                                }}
                                            >
                                                {equipo.tipo || "—"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background: "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#6b778c",
                                                    fontSize: 12,
                                                }}
                                            >
                                                N° Serie
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                    fontSize: 13,
                                                }}
                                            >
                                                {equipo.serie || "—"}
                                            </strong>
                                        </div>
                                    </div>
                                ) : null;
                            })()}

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    background: "#f4f9fd",
                                    border: "1px solid #cce1f2",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: "#2185d0",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        color: "#5e6c84",
                                        fontSize: 12,
                                        lineHeight: 1.5,
                                    }}
                                >
                                    El documento permanecerá abierto y podrá seguir
                                    agregando equipos mientras no sea confirmado.
                                </div>
                            </div>
                        </div>

                        {/* FOOTER */}
                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={cancelDelete}
                            >
                                Cancelar
                            </Button>

                            <Button
                                color="orange"
                                type="button"
                                icon
                                labelPosition="left"
                                onClick={borrarItem}
                            >
                                <Icon name="trash alternate" />
                                Eliminar equipo
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* =====================================================
    MODAL CONFIRMAR DOCUMENTO DE SALIDA
===================================================== */}

            {showConfirmarDocumento && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 480,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#e9f8ef",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="check circle"
                                    style={{
                                        margin: 0,
                                        color: "#21ba45",
                                        fontSize: 20,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                    }}
                                >
                                    Confirmar documento de salida
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Se procesará la salida de los equipos.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}
                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Desea confirmar definitivamente este documento
                                de salida?
                            </div>

                            <div
                                style={{
                                    background: "#f8fafc",
                                    border: "1px solid #e5e9ef",
                                    borderRadius: 7,
                                    padding: "13px 14px",
                                    marginBottom: 16,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: 12,
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        Tipo de salida
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 13,
                                        }}
                                    >
                                        {nomTipoOut || "—"}
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: 12,
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        Equipos incluidos
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 14,
                                        }}
                                    >
                                        {dataSalida.length}
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: 12,
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#6b778c",
                                            fontSize: 12,
                                        }}
                                    >
                                        Destino
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 13,
                                            textAlign: "right",
                                        }}
                                    >
                                        {entidad || "—"}
                                    </strong>
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    background: "#f1faf5",
                                    border: "1px solid #ccebd8",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: "#21ba45",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    Al confirmar, el documento quedará cerrado y el
                                    estado de los equipos será actualizado según el
                                    tipo de salida seleccionado.
                                </div>
                            </div>
                        </div>

                        {/* FOOTER */}
                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={() =>
                                    setShowConfirmarDocumento(false)
                                }
                            >
                                Cancelar
                            </Button>

                            <Button
                                positive
                                type="button"
                                icon
                                labelPosition="left"
                                onClick={async () => {
                                    setShowConfirmarDocumento(false);
                                    setConfirmandoDocumento(true);
                                    setCargando(true);

                                    try {
                                        await actualizarDocs();
                                    } finally {
                                        setConfirmandoDocumento(false);
                                        setCargando(false);
                                    }
                                }}
                            >
                                <Icon name="check" />
                                Confirmar salida
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* =====================================================
    MODAL ANULAR DOCUMENTO
===================================================== */}

            {showConfirmationAnular && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 460,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#ffebe6",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="exclamation triangle"
                                    style={{
                                        margin: 0,
                                        color: "#db2828",
                                        fontSize: 19,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                    }}
                                >
                                    Anular documento de salida
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Esta acción afecta al documento completo.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}
                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Está seguro de que desea anular este documento
                                de salida?
                            </div>

                            {(() => {
                                const documento = [...cabecera, ...cabecera1].find(
                                    (d) => d.id === itemAnular
                                );

                                return documento ? (
                                    <div
                                        style={{
                                            background: "#f8fafc",
                                            border: "1px solid #e5e9ef",
                                            borderRadius: 7,
                                            padding: "12px 14px",
                                            marginBottom: 16,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#6b778c",
                                                    fontSize: 12,
                                                }}
                                            >
                                                Documento
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                }}
                                            >
                                                {documento.tipdoc || "SALIDA"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background: "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#6b778c",
                                                    fontSize: 12,
                                                }}
                                            >
                                                N° Documento
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                }}
                                            >
                                                {documento.numdoc || "—"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background: "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: 12,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#6b778c",
                                                    fontSize: 12,
                                                }}
                                            >
                                                Destino
                                            </span>

                                            <strong
                                                style={{
                                                    color: "#253858",
                                                    textAlign: "right",
                                                }}
                                            >
                                                {documento.entidad || "—"}
                                            </strong>
                                        </div>
                                    </div>
                                ) : null;
                            })()}

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    background: "#fff7f5",
                                    border: "1px solid #ffd5cc",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="warning sign"
                                    style={{
                                        color: "#db2828",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    Los equipos asociados al documento pendiente
                                    serán eliminados del detalle y la salida quedará
                                    anulada.
                                </div>
                            </div>
                        </div>

                        {/* FOOTER */}
                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={cancelAnular}
                            >
                                Cancelar
                            </Button>

                            <Button
                                negative
                                type="button"
                                icon
                                labelPosition="left"
                                onClick={anular}
                            >
                                <Icon name="ban" />
                                Anular documento
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            {/* =====================================================
    MODAL BUSCAR EQUIPOS
===================================================== */}

            {modalBuscarEquipo && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "95vw",
                            maxWidth: 1050,
                            maxHeight: "88vh",
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "16px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 15,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                }}
                            >
                                <div
                                    style={{
                                        width: 42,
                                        height: 42,
                                        minWidth: 42,
                                        borderRadius: 8,
                                        background: "#e5f7f7",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Icon
                                        name="boxes"
                                        style={{
                                            margin: 0,
                                            color: "#0d9da5",
                                            fontSize: 18,
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontSize: 17,
                                            fontWeight: 700,
                                            color: "#172b4d",
                                        }}
                                    >
                                        Buscar Equipos
                                    </div>

                                    <div
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                            marginTop: 3,
                                        }}
                                    >
                                        Seleccione el equipo que desea incorporar
                                        al documento.
                                    </div>
                                </div>
                            </div>

                            <Button
                                basic
                                icon
                                size="mini"
                                type="button"
                                onClick={() => {
                                    setModalBuscarEquipo(false);
                                    setTextoBusquedaEquipo("");
                                }}
                            >
                                <Icon name="close" />
                            </Button>
                        </div>

                        {/* BUSCADOR */}
                        <div
                            style={{
                                padding: "16px 20px",
                                borderBottom: "1px solid #edf0f4",
                                background: "#f8fafc",
                            }}
                        >
                            <Input
                                fluid
                                icon={
                                    <Icon
                                        name="search"
                                        style={{
                                            color: "#0d9da5",
                                        }}
                                    />
                                }
                                iconPosition="left"
                                placeholder="Buscar por serie, tipo, marca, modelo o RFID..."
                                value={textoBusquedaEquipo}
                                onChange={(e) =>
                                    setTextoBusquedaEquipo(e.target.value)
                                }
                                autoFocus
                            />

                            <div
                                style={{
                                    marginTop: 8,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    fontSize: 11,
                                    color: "#8793a5",
                                }}
                            >
                                {!cargandoBusqueda && (
                                    <strong>
                                        {equiposFiltrados.length} equipo(s)
                                    </strong>
                                )}
                            </div>
                        </div>

                        {/* TABLA */}
                        <div
                            style={{
                                flex: 1,
                                minHeight: 0,
                                overflow: "auto",
                            }}
                        >
                            <Table
                                celled
                                compact="very"
                                selectable
                                unstackable
                                style={{
                                    margin: 0,
                                    minWidth: 850,
                                    border: 0,
                                }}
                            >
                                <Table.Header>
                                    <Table.Row>
                                        {[
                                            "Tipo",
                                            "Marca",
                                            "Modelo",
                                            "Serie",
                                            "RFID",
                                        ].map((titulo) => (
                                            <Table.HeaderCell
                                                key={titulo}
                                                style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background: "#f8fafc",
                                                    color: "#344563",
                                                }}
                                            >
                                                {titulo}
                                            </Table.HeaderCell>
                                        ))}

                                        <Table.HeaderCell
                                            textAlign="center"
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                color: "#344563",
                                                width: 90,
                                            }}
                                        >
                                            Acción
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {cargandoBusqueda ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="6"
                                                textAlign="center"
                                                style={{
                                                    padding: "38px 20px",
                                                }}
                                            >
                                                <Icon
                                                    loading
                                                    name="spinner"
                                                    style={{
                                                        color: "#0d9da5",
                                                        marginRight: 8,
                                                    }}
                                                />

                                                Cargando equipos...
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : equiposFiltrados.length === 0 ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="6"
                                                textAlign="center"
                                                style={{
                                                    padding: "40px 20px",
                                                }}
                                            >
                                                <Icon
                                                    name="search"
                                                    style={{
                                                        display: "block",
                                                        margin: "0 auto 10px",
                                                        color: "#b3bac5",
                                                        fontSize: 24,
                                                    }}
                                                />

                                                <div
                                                    style={{
                                                        color: "#526273",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    No se encontraron equipos
                                                </div>

                                                <div
                                                    style={{
                                                        color: "#98a1af",
                                                        fontSize: 12,
                                                        marginTop: 4,
                                                    }}
                                                >
                                                    Modifique el criterio de búsqueda.
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : (
                                        equiposFiltrados.map((eq) => (
                                            <Table.Row
                                                key={eq.id}
                                                style={{
                                                    cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                    seleccionarEquipoBusqueda(eq)
                                                }
                                            >
                                                <Table.Cell>
                                                    {eq.tipo || "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {eq.marca || "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {eq.modelo || "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    <strong
                                                        style={{
                                                            color: "#253858",
                                                        }}
                                                    >
                                                        {eq.serie || "-"}
                                                    </strong>
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {eq.rfid || "-"}
                                                </Table.Cell>

                                                <Table.Cell textAlign="center">
                                                    <Button
                                                        type="button"
                                                        size="mini"
                                                        icon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            seleccionarEquipoBusqueda(eq);
                                                        }}
                                                        style={{
                                                            background: "#0d9da5",
                                                            color: "#ffffff",
                                                            borderRadius: 6,
                                                        }}
                                                    >
                                                        <Icon name="plus" />
                                                    </Button>
                                                </Table.Cell>
                                            </Table.Row>
                                        ))
                                    )}
                                </Table.Body>
                            </Table>
                        </div>

                        {/* FOOTER */}
                        <div
                            style={{
                                padding: "13px 20px",
                                borderTop: "1px solid #e5e9ef",
                                background: "#f8fafc",
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={() => {
                                    setModalBuscarEquipo(false);
                                    setTextoBusquedaEquipo("");
                                }}
                            >
                                <Icon name="close" />
                                Cerrar
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            <Spinner
                loading={cargando || guardandoCabecera || confirmandoDocumento}
                mensaje={
                    guardandoCabecera
                        ? "Guardando cabecera..."
                        : confirmandoDocumento
                            ? "Confirmando salida..."
                            : "Procesando..."
                }
            />
        </Container>
    );

};
export default Salidas;